export default "__VITE_ASSET__CE1Wuf9P__";